<template>
    <div>
        <div class="navigator mb-4">
            <h2 class="mr-auto">Agents Report</h2>
            <range-picker v-model="selectedFilters.dateRange" @input="getReport"></range-picker>
        </div>

        <div class="report-area pb-4">
            <div class="col-sm-12 d-flex justify-content-end my-2">
                <uib-pagination v-if="serviceResponse" v-model="pagination" :total-items="serviceResponse.pageInfo.totalItemCount" :items-per-page="pagination.itemsPerPage" :boundary-link-numbers="false" :max-size="7" @change="pageChanged"></uib-pagination>
            </div>

            <div class="col-sm-12">
                <list v-if="serviceResponse" :header="header" :body="body" :rows="serviceResponse.result"></list>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import List from '@/tools/list/baseList'
    import rangePicker from '../../tools/rangePicker/rangePicker'

    export default {
        data() {
            return {
                selectedFilters:{
                    dateRange: [
                        moment().startOf('day').format('YYYY-MM-DD'),
                        moment().add(2, 'month').endOf('day').format('YYYY-MM-DD')
                    ]
                },
                pagination:{
                    currentPage: 1,
                    itemsPerPage: 25,
                },
                serviceUrl: '/api/booking/ReportingBookingAgentSales',
                serviceResponse: null,
            }
        },
        created() {
            this.getReport();
        },
        computed: {
            ...mapGetters([
                'account'
            ]),
            header() {
                let vm = this;

                return {
                    selection: {
                        active: false,
                        event: function() {}
                    },
                    list: {
                        agentId: 'Id',
                        agentName: 'Name',
                        bookingTicket: 'Ticket',
                        departureDate: 'Event Date',
                        productName: 'Product',
                        totalGrossprice: 'PVP',
                        commissionAmount: 'Commission',
                        commissionValue: 'Commission Amount',
                    },
                };
            },
            body() {
                let vm = this;

                return {
                    selection: {
                        active: false,
                        event: function() {}
                    },
                    customRowEvent: function() {},
                    customCells: {
                        bookingTicket(row) {
                            return vm.formatTicketNumber(row.bookingTicket);
                        },
                        departureDate(row) {
                            return moment(row.departureDate).format('YYYY-MM-DD hh:mm');
                        },
                        totalGrossprice(row) {
                            return vm.formatPrice(row.totalGrossprice) + '€';
                        },
                        commissionAmount(row) {
                            if (Number(row.commissionAmount) > 0) {
                                return row.commissionAmount + '%';
                            } else {
                                return '-';
                            }
                        },
                        commissionValue(row) {
                            if (Number(row.commissionValue) > 0) {
                                return row.commissionValue + '€';
                            } else {
                                return '-';
                            }
                        },
                    },
                    customClassCell: {
                        agentId : 'pointer',
                        agentName : 'pointer',
                    }
                }
            },
        },
        methods: {
            getReport() {
                axios.get(this.serviceUrl, {
                    params: {
                        page: this.pagination.currentPage,
                        pageSize: this.pagination.itemsPerPage,
                        's.supplierId': this.account.supplierId,
                        's.dateStart': moment(this.selectedFilters.dateRange[0]).format('YYYY-MM-DD'),
                        's.dateEnd': moment(this.selectedFilters.dateRange[1]).format('YYYY-MM-DD'),
                    }
                }).then(response => {
                    if (response.status === 200) {
                        this.serviceResponse = response.data;
                    }
                }).catch(err => {
                    throw err;
                })
            },
            pageChanged() {
                this.getReport();
            }
        },
        components: {
            vSelect: extendedVSelect,
            List,
            rangePicker
        }
    }
</script>

<style lang="scss" scoped>
    .report-area {
        height: 84vh;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// reportSales.vue?1572858a